<template>
  <div class="aha-tabs">
    <!-- Tab navigation -->
    <div class="aha-tab-list-wrp">
      <ul class="aha-tab-list">
        <li
          v-for="tab in tabs"
          :key="tab.title"
          class="aha-tab-title"
          :data-text="tab.title"
          :class="{ active: tab.active }"
          @click="openTab($event, tab)"
        >
          {{ tab.title }}
        </li>
      </ul>
    </div>

    <!-- Tab content -->
    <div class="aha-tab-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    activeIndex: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      tabs: [],
      activeTab: null,
    }
  },
  watch: {
    activeIndex(newIndex) {
      this.openTab(null, this.tabs[+newIndex])
    },
  },
  mounted() {
    if (!this.tabs.length) {
      throw new Error('tab-list used without tab-item')
    }

    const activeTab = this.tabs[this.activeIndex] || this.tabs[0]
    activeTab.open()

    this.activeTab = activeTab
  },
  methods: {
    addTab(tab) {
      this.tabs.push(tab)
    },
    openTab(e, tab) {
      if (tab.disabled) {
        return
      }

      this.activeTab.close()
      tab.open()

      const index = this.tabs.indexOf(tab)

      this.$emit('change', e, tab, index)
      this.$emit('update:activeIndex', index)

      this.activeTab = tab
    },
  },
}
</script>

<style lang="scss" scoped>
  .aha-tabs {
    @apply flex flex-col lg:flex-row;
  }
  .aha-tab-list-wrp {
    @apply m-0 mb-4;
    @apply sm:mr-10;
    @apply overflow-auto md:overflow-hidden;
  }
  .aha-tab-list {
    min-width: 12rem;
  }
  .aha-tab-title {
    @apply p-3 cursor-pointer inline-block lg:block;
    min-width: 5rem;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
  }
  .aha-tab-title.active {
    @apply bg-secondary-20 rounded-md;
  }
  .aha-tab-content {
    @apply w-full lg:w-2/3;
  }
@media screen and (max-width: 480px) {
  .aha-tab-list-wrp {
    max-width: 480px;
    overflow-x: scroll;
  }
  .aha-tab-list {
    min-width: 30rem;
    padding-bottom: 1rem;
  }
}
</style>
